<div class="flex w-full gap-4">
	@if (features.vehicleRoadWorthyChecks) {
		<div
			class="card-frame"
			[class]="
				roadWorthyChecks().length !== 0
					? 'bg-green-400 dark:bg-green-900'
					: 'bg-yellow-400 dark:bg-yellow-900'
			">
			@if (roadWorthyChecks().length !== 0) {
				<app-state-badge
					large
					[ultraToolTip]="
						'vehicles|record|summary-section|active-road-worthy-checks|tooltip'
							| transloco
					"
					[state]="stateBadgeEnum.SUCCESS" />
				<div class="flex gap-2">
					<app-vehicle-road-worthy-checks-link-pill
						[displayValue]="roadWorthyChecks()[0].code"
						[id]="roadWorthyChecks()[0].sourceId" />
				</div>
			} @else {
				<app-state-badge large [state]="stateBadgeEnum.WARNING" />
				{{
					'vehicles|record|summary-section|active-road-worthy-checks|empty'
						| transloco
				}}
			}
		</div>
	}

	@if (features.vehicleInsurances) {
		<div
			class="card-frame"
			[class]="
				insurances().length !== 0
					? 'bg-green-400 dark:bg-green-900'
					: 'bg-yellow-400 dark:bg-yellow-900'
			">
			@if (insurances().length !== 0) {
				<app-state-badge
					large
					[ultraToolTip]="
						'vehicles|record|summary-section|active-insurances|tooltip'
							| transloco
					"
					[state]="stateBadgeEnum.SUCCESS" />
				<div class="flex gap-2">
					<app-vehicle-insurances-link-pill
						[displayValue]="insurances()[0].code"
						[id]="insurances()[0].sourceId" />
				</div>
			} @else {
				<app-state-badge large [state]="stateBadgeEnum.WARNING" />
				{{
					'vehicles|record|summary-section|active-insurances|empty' | transloco
				}}
			}
		</div>
	}

	@if (features.vehicleRoadTaxes) {
		<div
			class="card-frame"
			[class]="
				roadtaxes().length !== 0
					? 'bg-green-400 dark:bg-green-900'
					: 'bg-yellow-400 dark:bg-yellow-900'
			">
			@if (roadtaxes().length !== 0) {
				<app-state-badge
					large
					[ultraToolTip]=""
					[state]="stateBadgeEnum.SUCCESS" />
				<div class="flex gap-2">
					<app-vehicle-road-taxes-link-pill
						[displayValue]="roadtaxes()[0].code"
						[id]="roadtaxes()[0].sourceId" />
				</div>
			} @else {
				<app-state-badge large [state]="stateBadgeEnum.WARNING" />
				{{
					'vehicles|record|summary-section|active-road-taxes|empty' | transloco
				}}
			}
		</div>
	}
</div>
